import GdaPromotional, { PROMOTION_CONTEXT } from './GdaPromotional';

export { PROMOTION_CONTEXT };
export default GdaPromotional;
